module.exports = __webpack_public_path__ + "static/media/call_participant_left.a0fe592.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/call_participant_left.mp3
// module id = 398
// module chunks = 1